import { FOOTER_FOOTNOTE_1_DESKTOP_BREAK_AFTER } from "@/app/(main)/_utils/footer";
import { cn } from "@workspace/ui/lib/utils";

type FooterFootnotesProps = {
  items: readonly string[];
  variant?: "dark" | "light";
};

function FootnoteBody({ text }: { text: string }) {
  const pos = text.indexOf(FOOTER_FOOTNOTE_1_DESKTOP_BREAK_AFTER);
  if (pos === -1) {
    return text;
  }
  const end = pos + FOOTER_FOOTNOTE_1_DESKTOP_BREAK_AFTER.length;
  return (
    <>
      {text.slice(0, end)}
      <br className="hidden md:block" aria-hidden />
      {text.slice(end)}
    </>
  );
}

export function FooterFootnotes({
  items,
  variant = "dark",
}: FooterFootnotesProps) {
  return (
    <div
      id="footer-footnotes"
      className="mb-10 md:mb-12 flex flex-col gap-4"
      data-testid="footer-footnotes"
    >
      {items.map((text, i) => (
        <p
          key={i}
          id={`footer-footnote-${i + 1}`}
          data-testid={`footer-footnote-${i + 1}`}
          className={cn(
            "text-xs font-normal leading-[16px] tracking-[-0.2px] opacity-50",
            variant === "dark" && "text-[#FFF]",
            variant === "light" && "text-grey",
          )}
        >
          <FootnoteBody text={text} />
        </p>
      ))}
    </div>
  );
}
